<template>
  <div class="about_container">
    <!-- <Indicator title="Kilka słów o nas" counter="01" content=" Możemy zaproponować Państwu szeroką gamę mebli kuchennych, które są wykonane z materiałów i systemów najwyższej jakości. Wykonujemy rówznież różnego rodzaju szafy, komody, biurka, zabudowę pawlaczy,oraz montaż szkła. Ściśle według uznań klientów. " /> -->
     <Indicator v-if="textList.length > 0" :title="textList[1].title" counter="01" :content="textList[1].content" />
    <div class="content">
      <h3 class="title_boxes">Proces zamówienia to kilka banalnych kroków</h3>
      <p class="check">Z resztą, sprawź sam</p>
    </div>
    <div class="boxes">
    <a style="color: #2c3e50; text-decoration: none" href="tel:600830436"><infoBox class="infoBox" contentText=" Pierwszym krokiem jest skontaktowanie się z nami i umówienie na pomiar. " contentHeader="Kontakt" :icon="require('../assets/phone.svg')"/></a>
    <infoBox class="infoBox" contentText=" Następnie spotkamy się o wcześniej umówionej porze na pomiar. " contentHeader="Pomiar" :icon="require('../assets/meas.svg')"/>
    <infoBox class="infoBox" contentText=" Gdy znamy wymiary i Twoje zalecenia zabieramy się do pracy. " contentHeader="Realizacja" :icon="require('../assets/delivery.svg')"/>
    <infoBox class="infoBox" contentText=" Ostatnim, finalnym krokiem jest dostawa i montaż mebli. " contentHeader="Dostawa" :icon="require('../assets/deliv2.svg')"/>
    </div>
      <div class="youtube_container">
        <iframe v-if="$mq === 'large'" width="560" height="315" src="https://www.youtube.com/embed/gh0Krs3FIl4?controls=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        <div class="youtube_text">
          <h1 class="youtube_h1">System Aventos</h1>
          <p class="youtube_p">System podnośników do frontów górnych AVENTOS nadaje szafkom wysoki komfort ruchu. 
            Nawet duże i ciężkie fronty poruszają się lekko. Rozwiązania z rodziny AVENTOS są wyjątkowo praktyczne. 
            Fronty otwierane do góry znikają z obszaru pracy oferując niczym niezakłócony dostęp do wnętrza szafki.
          </p>
              <button v-if="$mq === 'medium'" class="video" @click="showImage">Wideo</button>
        </div>
      </div>
  </div>
</template>

<script>
import Indicator from '../components/Indicator.vue';
import infoBox from '../components/infoBox.vue';
import { mapActions, mapState } from 'vuex';
export default {
    name: 'About',
    components:{
      Indicator,
      infoBox
    },
    computed:{
      ...mapState({
        textList: state=>state.texts.textList
      })
    },
    methods:{
      ...mapActions(['showImage'])
    },
}
</script>

<style scoped lang="scss">
.about_container{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.check{
  margin-bottom: 12px;
}
.content{
  padding: 0 34px;
}
.boxes{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.video{
  width: 115px;
  height: 40px;
  border: 2px solid black;
  background: none;
  margin: 12px 0;
}
.youtube_text{
  padding: 24px 34px;
}
@media(min-width:1440px){
  .boxes{
    flex-direction: row;
    margin: 32px 0 64px 0;
  }
  .box_container{
    margin: 0 6px;
  }
  .title_boxes{
    font-size: 32px;
  }
  .check{
    font-size: 18px;
  }
  .video-heading{
    font-size: 32px;
    margin-bottom: 24px;
  }
  .youtube_container{
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin-bottom: 62px;
  }
  .youtube_text{
    margin: 0 32px;
  }
  .youtube_p{
    width: 300px;
  }
}
// @media (max-width: 640px) and (orientation: landscape){
//   .boxes{
//     width: 100%;
//     padding: 0 34px;
//     display: flex;
//     flex-direction: row;
//     flex-wrap: wrap;
//   }
//   .infoBox{
//     width: 240px;
//     margin: 12px;
//   }
// }
@media (min-width: 600px){
  .boxes{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
  .infoBox{
    width: 250px;
    margin: 6px;
  }
}
</style>